import { QueryPagination } from '../types';

//  Creates a pagination query string and page number
const createQueryPagination = ({ limit = 200, page = 0, offset }: QueryPagination = {}) => {
  const paginationQueryParams = new URLSearchParams();

  const offsetByPage = page ? page * limit : 0;
  // Prefer offset if provided, otherwise fallback to page
  const _offset = offset || offsetByPage;
  paginationQueryParams.set('limit', limit.toString());
  paginationQueryParams.set('offset', _offset.toString());

  return { page, paginationQuery: paginationQueryParams.toString(), limit };
};

export { createQueryPagination };
